module.exports = __webpack_public_path__ + "img/Pink.f3cf11a6.png";